import { travelDateLocalized } from '@/utils/travels'

export class CarParkDriver {
  constructor ({
    user_id = -1,
    username = '',
    email = '',
    avatar = '',
    role = -1,
    trips_after = 0,
    trips_before = 0,
    restricted = false
  } = {}) {
    this.userId = user_id
    this.username = username
    this.email = email
    this.avatar = avatar
    this.role = role
    this.tripsAfter = trips_after > 0 ? new Date(trips_after) : null
    this.tripsBefore = trips_before > 0 ? new Date(trips_before) : null
    this.restricted = restricted
  }

  get tripsAfterFormatted () {
    return this.tripsAfter ? travelDateLocalized(this.tripsAfter) : '-'
  }

  get tripsBeforeFormatted () {
    return this.tripsBefore ? travelDateLocalized(this.tripsBefore) : '-'
  }
}
